<template>
  <div>
    <string :settings="item" v-if="item.type == 'string' && (item.name != 'url' && item.name != 'link')" v-model="value" :defaultValue="value" :id="id" />

    <link-input :settings="item" v-if="item.type == 'string' && (item.name == 'url' || item.name == 'link')" v-model="value" :defaultValue="value" :id="id" />

    <email-input v-model="value" :defaultValue="value" v-if="item.type == 'email'" :options="item.options" :id="id" />

    <scheduler-input v-model="value" :defaultValue="value" v-if="item.type == 'schedule'" :options="item.options" :id="id" />

    <number :settings="item" v-if="item.type == 'number'" v-model="value" :defaultValue="value" :id="id" />

    <boolean :settings="item" v-if="item.type == 'boolean'" v-model="value" :defaultValue="value" :id="id" />

    <date v-model="value" :defaultValue="value" v-if="item.type == 'date'" :id="id" />

    <timepicker v-model="value" :defaultValue="value" v-if="item.type == 'time'" :id="id" />

    <date-time-input v-model="value" :defaultValue="value" v-if="item.type == 'datetime'" :id="id" />

    <time-span-input v-model="value" :defaultValue="value" v-if="item.type == 'timespan'" :id="id" />

    <long-text-input v-model="value" :defaultValue="value" v-if="item.type == 'longtext'" :id="id" />

    <rich-text-input v-model="value" :defaultValue="value" v-if="item.type == 'richtext'" :id="id" />

    <file-upload-input v-model="value" :defaultValue="value" v-if="item.type == 'file'" :id="id" />

    <image-upload-input v-model="value" :defaultValue="value" v-if="item.type == 'image'" :id="id" />

    <color-picker-input v-model="value" :defaultValue="value" v-if="item.type == 'color'" :id="id" />

    <select-input v-model="value" :defaultValue="value" v-if="item.type == 'select'" :options="item.options" :id="id" />

    <size-input v-model="value" :defaultValue="value" v-if="item.type == 'size'" :options="item.options" :id="id" />

    <place-input :settings="item" v-if="item.type == 'place'" v-model="value" :defaultValue="value" :id="id" />

    <div v-if="item.type == 'object'" v-for="(object, index) in item.inputs" class="object_input" style="display: block; margin-bottom:30px;">
        <label>
          <h1 class="form__item__name">{{object.label}}</h1>
          <small class="form__item__description">{{object.description}}</small>
        </label>

      <item :id="getFormName([item.name, item.type, object.type].join('-'), index)" v-model="value[object.name]" :defaultValue="value[object.name]" :item="object" />
    </div>
  </div>
</template>

<script>
import TimeSpanInput from './TimeSpanInput.vue'
import RichTextInput from './RichTextInput.vue'
import FileUploadInput from './FileUploadInput.vue'
import ImageUploadInput from './ImageUploadInput.vue'
import String from './String.vue'
import Number from './Number.vue'
import Boolean from './Boolean.vue'
import Date from './Date.vue'
import Timepicker from './Timepicker.vue'
import DateTimeInput from './DateTimeInput.vue'
import LongTextInput from './LongTextInput.vue'
import ColorPickerInput from './ColorPickerInput.vue'
import SelectInput from './SelectInput.vue'
import SizeInput from './SizeInput.vue'
import LinkInput from './LinkInput.vue'
import SchedulerInput from './Scheduler'
import EmailInput from './EmailInput'
import PlaceInput from './PlaceInput'

export default {
  name: 'Item',
  components: {
    Date,
    TimeSpanInput,
    LongTextInput,
    RichTextInput,
    FileUploadInput,
    ImageUploadInput,
    String,
    Number,
    Boolean,
    Timepicker,
    DateTimeInput,
    ColorPickerInput,
    SelectInput,
    SizeInput,
    LinkInput,
    SchedulerInput,
    EmailInput,
    PlaceInput
  },
  props: ['item', 'defaultValue', 'id'],
  methods: {
    getFormName(type, index) {
      const rand = parseInt(Math.random()*100000000, 0);
      return `${type}-${index}-${rand}`;
    },
  },
  data () {
    let obj = {
      value: this.defaultValue || null
    }

    return obj;
  },
  mounted () {
    if (this.item.subtype) {
      this.item.type = this.item.subtype.replace('broadstreetads/', '');
    }
  },
  watch: {
    value(newVal){
      this.$emit('input', newVal);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/configurator/Item.vue